<template>
  <button
    role="switch"
    type="button"
    :aria-checked="proxySelected.toString()"
    :aria-labelledby="isFor"
    class="header-switch"
    @click.prevent="toggle"
    @keypress.enter.prevent="toggle">
    <span :id="isFor" class="header-switch__label">{{ labelText }}</span>
    <span class="header-switch__switch">
      <span class="header-switch__text header-switch__text--on" aria-hidden="true">{{ onText }}</span>
      <span class="header-switch__text header-switch__text--off" aria-hidden="true">{{ offText }}</span>
    </span>
  </button>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      required: true
    },
    labelText: {
      type: String,
      required: true
    },
    isFor: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      proxySelected: false
    }
  },
  computed: {
    onText() {
      return this.tStatic('onText')
    },
    offText() {
      return this.tStatic('offText')
    }
  },
  watch: {
    value(newVal) {
      if(newVal !== this.proxySelected) {
        this.proxySelected = newVal
      }
    }
  },
  mounted() {
    this.proxySelected = this.value
  },
  methods: {
    toggle() {
      this.proxySelected = !this.proxySelected
      this.$emit('toggle', this.proxySelected)
    }
  }
}
</script>

<style lang="scss">

.header-switch {
  @include reset-button;
  @include body-smaller-semi-bold;
  color: color(bar-text);
  user-select: none;
  display: flex;
  align-items: center;
}

.header-switch__label {
  display: inline-block;
  margin-right: measure(half);
}

.header-switch__switch {
  @include caption-semi-bold;
  position: relative;
  display: flex;
  border: 2px solid color(bar-text);
  background-color: transparent;
  border-radius: 12px;
  padding: 3px;
}

.header-switch__text {
  text-align: center;
  border-radius: 8px;
  transition: all .4s ease;
  padding: 1px 6px 1px 6px;
}

.header-switch[aria-checked="true"] .header-switch__text--on,
.header-switch__text--off {
  background-color: color(bar-text);
  color: color(text-gray-dark)
}

.header-switch[aria-checked="true"] .header-switch__text--off {
  background-color: transparent;
  color: color(bar-text);
}
</style>
